import React, { useCallback, useEffect, useState } from 'react'
import HOC from '../../components/HOC/HOC'
import dash from '../../css/style.module.css';

import { FaUserPlus } from "react-icons/fa6";
import { IoDocumentText } from "react-icons/io5";
import { MdQuiz } from "react-icons/md";
import { MdTopic } from "react-icons/md";
import { IoIosArrowForward } from "react-icons/io";
import { db } from '../../components/Firebase/Firebase-config';
import {
    doc,
    onSnapshot,
} from 'firebase/firestore';

import img from '../../assest/img1.png'
import img1 from '../../assest/img2.png'
import img2 from '../../assest/img3.png'
import img3 from '../../assest/img4.png'
import img4 from '../../assest/img5.png'
import img5 from '../../assest/loading1.gif'

import img6 from '../../assest/img7.png'

import SingleBarChart from './DashChart';
import { Link, useNavigate } from 'react-router-dom';
import { getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';
import { formatDistanceToNow } from 'date-fns';

const Dashboard = () => {
    const navigate = useNavigate()
    const users = [
        {
            id: 1,
            name: "Robert Fox",
            time: "2 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img,
        },
        {
            id: 2,
            name: "Dianne Russell",
            time: "3 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img1,
        },
        {
            id: 3,
            name: "Darlene Robertson",
            time: "5 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img2,
        },
        {
            id: 4,
            name: "Jerome Bell",
            time: "2 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img3,
        },
        {
            id: 5,
            name: "Robert Fox",
            time: "3 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img4,
        },
        {
            id: 6,
            name: "Darlene Robertson",
            time: "5 hrs ago",
            message: "Lorem ipsum dolor sit amet sum sd",
            image: img4,
        },
        // Add more users as needed
    ];
    const [data, setData] = useState({});
    const [chartData, setChartData] = useState(null); // Chart data for rendering
    const [period, setPeriod] = useState('quarterly'); // Default period    
    const [loading, setLoading] = useState(false);
    const [chartloading, setChartLoading] = useState(false);
    const [userdata, setUserData] = useState([])

    const fetchData = async () => {
        await getApi(endPoints.getdashboardtotal, {
            setResponse: setData,
            setLoading,
            errorMsg: 'Failed to fetch data!'
        });
    };

    const fetchChartData = async () => {
        if (!period) return; // Don't fetch if no period is selected
        await getApi(endPoints.getallChart(period), {
            setResponse: (response) => {
                const formattedData = response.data.map((item) => ({
                    label: item.label,
                    value: item.totalRevenue,
                }));
                setChartData(formattedData);
            },
            setChartLoading,
            errorMsg: 'Failed to fetch data!',
        });
    };

    useEffect(() => {
        fetchChartData();
        fetchData();
    }, [period]);

    const [search, setSearch] = useState('')
    const [limit, setLimit] = useState(8);
    const adminData = JSON.parse(localStorage.getItem("adminData")) || {};

    const fetchUserData = useCallback(async () => {
        await getApi(endPoints.getalluser(1, limit, search), {
            setResponse: async (response) => {
                const users = response?.data?.docs || [];

                const updatedUsers = await Promise.all(
                    users.map(async (user) => {
                        try {
                            const chatId = `${user._id}_${adminData?.data?._id}`;
                            const chatRef = doc(db, "chats", chatId);

                            return new Promise((resolve) => {
                                const unsubscribe = onSnapshot(chatRef, (docSnapshot) => {
                                    if (docSnapshot.exists()) {
                                        const messages = docSnapshot.data().messages || [];
                                        const lastMessage = messages?.length > 0 ? messages[messages.length - 1] : null;
                                        resolve({
                                            ...user,
                                            lastMessage: lastMessage?.message || 'No messages yet',
                                            lastMessageTime: lastMessage?.timestamp || null,
                                            tag: lastMessage?.tag || null
                                        });
                                    } else {
                                        resolve({ ...user, lastMessage: 'No messages yet', lastMessageTime: null });
                                    }
                                });

                                return () => unsubscribe();
                            });
                        } catch (error) {
                            console.error(`Error fetching last message for user ${user._id}:`, error);
                            return { ...user, lastMessage: 'Error loading message', lastMessageTime: null };
                        }
                    })
                );

                const sortedUsers = updatedUsers.sort((a, b) => {
                    return new Date(b.lastMessageTime || 0) - new Date(a.lastMessageTime || 0);
                });

                setUserData(sortedUsers);
            },
            setLoading,
            errorMsg: 'Failed to fetch users!',
        });
    }, [limit, search, adminData?.data?._id]);


    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const getTimeAgo = (timestamp) => {
        return formatDistanceToNow(new Date(timestamp), { addSuffix: true });
    };

    return (
        <>
            <div className={dash.dashcontainer}>
                {loading ? (
                    <div className={dash.loadingnormal}>
                        <img src={img5} alt="Loading" width={100} height={100} />
                    </div>
                ) : (
                    <div className={dash.topdash}>
                        <Link to={'/staff-management/registered'} className={dash.link}>
                            <div className={dash.dashcount}>
                                <div className={dash.dashicons}>
                                    <FaUserPlus />
                                </div>
                                <div className={dash.dashcountmain}>
                                    <h6>{data?.data?.totalEmployee}</h6>
                                    <p>Total Employees</p>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/job-management/category'} className={dash.link}>
                            <div className={dash.dashcount} style={{ background: "#FFF4DE" }}>
                                <div className={dash.dashicons} style={{ background: "#FFA800" }}>
                                    <IoDocumentText />
                                </div>
                                <div className={dash.dashcountmain}>
                                    <h6>{data?.data?.totalJobs}</h6>
                                    <p>Total Jobs</p>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/orders'} className={dash.link}>
                            <div className={dash.dashcount} style={{ background: "#DCFCE7" }}>
                                <div className={dash.dashicons} style={{ background: "#3CD856" }}>
                                    <MdQuiz />
                                </div>
                                <div className={dash.dashcountmain}>
                                    <h6>{data?.data?.totalOrders}</h6>
                                    <p>Total Orders</p>
                                </div>
                            </div>
                        </Link>
                        <Link to={'/voucher-Offers'} className={dash.link}>
                            <div className={dash.dashcount} style={{ background: "#F3E8FF" }}>
                                <div className={dash.dashicons} style={{ background: "#BF83FF" }}>
                                    <MdTopic />
                                </div>
                                <div className={dash.dashcountmain}>
                                    <h6>{data?.data?.totalVouchers}</h6>
                                    <p>Total Vouchers</p>
                                </div>
                            </div>
                        </Link>
                    </div>

                )}
                <div className={dash.dashsubcontainer}>
                    <div className={dash.dashleftcontainer}>
                        <div className={dash.dashleftitem}>
                            <div className={dash.dashleftitemtop}>
                                <h6>Expenses</h6>
                                {/* <div className={dash.dashselect}>
                                        <select name="" id="">
                                            <option value="">Half-yearly</option>
                                            <option value="">Half-yearly</option>
                                            <option value="">Half-yearly</option>
                                        </select>
                                    </div> */}
                            </div>
                            {loading ? (
                                <div className={dash.loadingnormal}>
                                    <img src={img5} alt="Loading" width={100} height={100} />
                                </div>
                            ) : (
                                <div className={dash.dashleftitembottom}>
                                    <div className={dash.dashcount} style={{ background: "#F3E8FF" }}>
                                        <div className={dash.dashicons} style={{ background: "#BF83FF" }}>
                                            <FaUserPlus />
                                        </div>
                                        <div className={dash.dashcountmain}>
                                            <h6>{data?.data?.totalBillings}</h6>
                                            <p>Total Billings</p>
                                        </div>
                                    </div>
                                    <div className={dash.dashcount} style={{ background: "#FFF4DE" }}>
                                        <div className={dash.dashicons} style={{ background: "#FFA800" }}>
                                            <IoDocumentText />
                                        </div>
                                        <div className={dash.dashcountmain}>
                                            <h6>{data?.data?.totalPaidTaxes}</h6>
                                            <p>Total Paid Taxes</p>
                                        </div>
                                    </div>
                                    <div className={dash.dashcount} style={{ background: "#E2FFFF" }}>
                                        <div className={dash.dashicons} style={{ background: "#09ADAD" }}>
                                            <MdQuiz />
                                        </div>
                                        <div className={dash.dashcountmain}>
                                            <h6>{data?.data?.totalProfits}</h6>
                                            <p>Total Profits</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className={dash.dashleftitem}>
                            <div className={dash.dashleftitemtop}>
                                <h6>Annual Revenue</h6>
                                <div className={dash.dashselect}>
                                    <select
                                        value={period}
                                        onChange={(e) => setPeriod(e.target.value)}
                                    >
                                        <option value="yearly">Yearly</option>
                                        <option value="half-yearly">Half-yearly</option>
                                        <option value="quarterly">Quarterly</option>
                                        <option value="monthly">Monthly</option>
                                    </select>
                                </div>
                            </div>
                            <div className={dash.dashleftitembottomchart}>
                                {chartData ? <SingleBarChart data={chartData} /> : <p>Loading chart...</p>}
                            </div>
                        </div>
                    </div>

                    <div className={dash.dashrightcontainer}>
                        <div className={dash.dashleftitemtop1}>
                            <h6>Chats</h6>
                            <div className={dash.dashselect1} onClick={() => navigate('/chats/user')}>
                                View All
                                <IoIosArrowForward color='#121212' size={15} />
                            </div>
                        </div>
                        <div className={dash.dashusers}>
                            {loading ? (
                                <div className="loadingnormal11">
                                    <img src={img5} alt="Loading" width={100} height={100} />
                                </div>
                            ) : userdata?.length === 0 ? (
                                <div className="loadingnormal11">
                                    <p>No data available.</p>
                                </div>
                            ) : (
                                userdata?.map((user) => (
                                    <div key={user._id} className={dash.dashuserchat}
                                        onClick={()=>navigate("/chats/user", { state: { userId: user } })}
                                    >
                            <div className={dash.dashuserimg}>
                                <img src={user.image ? user.image : img6} alt={`${user.firstName}'s profile`} />
                            </div>
                            <div className={dash.dashusername}>
                                <div className={dash.dashusertime}>
                                    <h6>{user.firstName ? user.firstName : "User"} {user.lastName}</h6>
                                    <p>{user?.lastMessageTime ? getTimeAgo(new Date(user?.lastMessageTime)) : ""}</p>
                                </div>
                                <div className={dash.dashusermessage}>
                                    <p>{user.lastMessage?.length > 15 ? `${user?.lastMessage?.substring(0, 15)}....` : user?.lastMessage || "lastMessage"}</p>
                                </div>
                            </div>
                        </div>
                        ))
                            )}
                    </div>
                </div>
            </div>
        </div >
        </>
    )
}

export default HOC(Dashboard)